export const PLATFORMS: Record<string, number> = {
    android: 1,
    ipad: 2,
    iphone: 4,
    desktop: 8
};